import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APIService, AccountMembership, VerifyEmailInput } from 'app/API.service.custom';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DataShareService } from 'services/data-share.service';
import { filter, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DialogRef } from 'app/shared/dialog';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatFormField } from '@angular/material/select';
import { NgClass, AsyncPipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
    selector: 'app-modify-registered-number',
    templateUrl: './modify-registered-number.component.html',
    styleUrls: ['./modify-registered-number.component.scss'],
    imports: [AlertComponent, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, MatButton, FlexModule, MatFormField, NgClass, ExtendedModule, MatInput, MatProgressSpinner, AsyncPipe]
})
export class ModifyRegisteredNumberComponent implements OnInit {

  activeAccount : AccountMembership;
  activAccountSubscription;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.India, CountryISO.UnitedStates];
  modifyNumberForm
  waitingForOtpEntering = false;
  formSubmittedWithNumber = false;
  userExists = false;
  otpSubmitted = false;
  verifyId = null;

  digit1 = new UntypedFormControl('', [Validators.required]);
  digit2 = new UntypedFormControl('', [Validators.required]);
  digit3 = new UntypedFormControl('', [Validators.required]);
  digit4 = new UntypedFormControl('', [Validators.required]);
  digit5 = new UntypedFormControl('', [Validators.required]);
  digit6 = new UntypedFormControl('', [Validators.required]);
  @ViewChild('digit1el', { static: false  }) digit1element: ElementRef;
  @ViewChild('digit2el', { static: false  }) digit2element: ElementRef;
  @ViewChild('digit3el', { static: false  }) digit3element: ElementRef;
  @ViewChild('digit4el', { static: false  }) digit4element: ElementRef;
  @ViewChild('digit5el', { static: false  }) digit5element: ElementRef;
  @ViewChild('digit6el', { static: false  }) digit6element: ElementRef;
  private allSubscriptions = new Subscription();

  constructor(
    private dataService: DataShareService,
    private formBuilder: UntypedFormBuilder,
    private api: APIService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: DialogRef,
  ) { }

  addNewNumber() {
    this.modifyNumberForm = this.formBuilder.group({
      registeredNumber: new UntypedFormControl(null, {
        validators: [Validators.required]
      })
    });
  }

  ngOnInit(): void {
    this.addNewNumber();
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        console.log("+++++++++++++ In ModifyRegisteredNumberComponent. The active account is :", this.activeAccount)
      }
    });
  }

  moveFocusToNext(){
    // Move focus to next field upon entry of a digit
    [2, 3, 4, 5, 6].forEach(digit => {
      const prev = this[`digit${digit - 1}`] as UntypedFormControl;
      const next = this[`digit${digit}element`] as ElementRef;
      this.allSubscriptions.add(prev.valueChanges.pipe(
        tap(() => {
          if (prev.value) {
            setTimeout(() => {
              next?.nativeElement?.focus();
              next?.nativeElement?.setSelectionRange(0, 1);
            }, 100)
            // next.nativeElement.focus();
            // next.nativeElement.setSelectionRange(0, 1);
          }
        })
      ).subscribe());
    });
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
        this.activAccountSubscription.unsubscribe();
    this.allSubscriptions.unsubscribe();
  }

  onResetModifyNumber(){
    this.modifyNumberForm.reset();
  }

  onSubmit(ev){
    console.log("on subit called ");
    ev.stopPropagation();
    if(!this.formSubmittedWithNumber){
      this.formSubmittedWithNumber = true; 
      let formValue = this.modifyNumberForm.value;
      let i = <VerifyEmailInput>{};
      i.name = this.activeAccount.user.name;
      i.accountId = this.activeAccount.accountId;
      i.phoneToVerify = formValue.registeredNumber.e164Number;
      i.verificationPurpose = "CHANGE_REGISTERED_NUMBER";
      console.log("the input to initiate verificaiton is ", i);
      this.api.VerifyEmail(i).then(event => {
        console.log('Verify call initiated ', event);
        this.formSubmittedWithNumber = false;
        if(event && event.verifyId == null){
          if(event.onErrorMessage = "USER_ALREADY_EXISTS"){
            this.userExists = true;
          }
          else{
            this.toastr.error("Some error occurred in verification");
          }
        }else if(event && event.verifyId != null){
          this.waitingForOtpEntering = true;
          //save verifyId in localstorage
          this.verifyId = event.verifyId;
          setTimeout(() => {
            this.moveFocusToNext();
          }, 300)
        }
      })
        .catch(e => {
          this.formSubmittedWithNumber = false;
          console.log('Error In Verification', e);
          this.showErrorInToastr(e, 'Error In Verification')
        });
    }
  }

  public async submitOTP() {
    if(!this.otpSubmitted && this.verifyId){
      this.otpSubmitted = true;
      if(this.digit1.valid && this.digit2.valid && this.digit3.valid && this.digit4.valid && this.digit5.valid && this.digit6.valid){
        const answer = [1, 2, 3, 4, 5, 6]
          .map(digit => (this[`digit${digit}`] as UntypedFormControl).value)
          .join('');
        let i = <VerifyEmailInput>{};
        i.verifyId = this.verifyId;
        i.enteredCode = answer;
        i.accountId = this.activeAccount.accountId;
        i.verificationPurpose = "CHANGE_REGISTERED_NUMBER";
        console.log("the input to initiate verificaiton is ", i);
        this.api.VerifyEmail(i).then(event => {
          console.log('otp verification done ', event);
          this.otpSubmitted = false;
          if(event.isVerified){
            this.toastr.success("Mobile Number Modified Successfully");
            this.dialog.close();
            window.location.reload();
          }
          else{
            this.toastr.error("Could not verify OTP");
          }
        })
          .catch(e => {
            this.formSubmittedWithNumber = false;
            console.log('Error In Verification', e);
            this.showErrorInToastr(e, 'Error In Verification')
          });
      }
    }
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

}
